<template>
    <form @submit.prevent="createState">
        <div>
            <label class="block mb-1" for="name">{{ $t('labels.name') }}</label>
            <InputText
                v-model="state.name"
                name="name"
                type="text"
                placeholder="name in Japanese"
                class="w-full"
                />      
                <p v-if="errors.name" class="text-sm text-danger">{{ errors.name[0] }}</p>          
        </div>
        <div class="mt-3">
            <label class="block mb-1" for="name">{{ $t('labels.name_en') }}</label>
            <InputText
                v-model="state.name_en"
                name="name_en"
                type="text"
                placeholder="name in English"
                class="w-full"
                />      
                <p v-if="errors.name_en" class="text-sm text-danger">{{ errors.name_en[0] }}</p>          
        </div>
        <div class="flex justify-end mt-6">
            <button :disabled="loading" class="px-6 py-2 text-white rounded outline-none bg-secondary ring-0">
                <span v-if="loading">Loading</span>
                <span v-else>{{ $t('actions.create') }}</span>
            </button>
        </div>
    </form>
</template>

<script setup>
import { ref , defineEmits} from 'vue';
import ApiService from '@/services/ApiService';
import { toast } from 'vue3-toastify';

//prime vue components
import InputText from 'primevue/inputtext';

const emit = defineEmits(['created']);

const state = ref({
    name : '',
    name_en : ''
})
const errors = ref({});
const loading = ref(false);

const createState = () => {
    loading.value = true;
    const id = toast.loading('Creating, please wait . . .');
    ApiService.post('states' , state.value).then(() => {
        loading.value = false;
        toast.update(id, {
            render: "Created state.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'success',
            isLoading: false,
        });
        emit('created');
    }).catch((res) => {
        loading.value = false;
        toast.update(id, {
            render: "Error creating state.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'error',
            isLoading: false,
        });
        errors.value = res?.response?.data && res?.response?.data?.errors ? res?.response?.data?.errors : {};
    })
}
</script>

<style scoped>

</style>